import { WorkItem } from "../types/workItems";
import { ResidentData } from "../types/dashboard";
import { mdsAssessmentStatusLabel } from "./helper";

// Map an MDS WorkItem to the ResidentData shape used by the table rows and the
// calendar view. Extracted so both the list (MDSAssessmentsTable) and calendar
// (MDSCalendarView) render identical data — NETSOL-12004 item #7 (calendar view).
export function mapWorkItemToResidentData(workItem: WorkItem): ResidentData {
  return {
    residentName: workItem.resident_name,
    dateOfBirth: workItem.date_of_birth || "N/A",
    payor: workItem.payer || "N/A",
    location: workItem.room || "N/A",
    admissionDate: workItem.admission_date || "N/A",
    mdsOcType: workItem.assessment_name || workItem.assessment_type,
    // NETSOL-11429: render whatever the backend has set on
    // assessment_reference_day. Do NOT fall back to scheduled_start_date — that
    // would mask backend gaps with a date the EHR doesn't recognize.
    ardDate: workItem.assessment_reference_day || "N/A",
    status: workItem.status,
    statusNormalized: mdsAssessmentStatusLabel(
      workItem.status,
      workItem.status_normalized
    ),
    statusBucket: workItem.status_normalized,
    assignedServices: workItem.unsigned_sections || "N/A",
    dueDate: workItem.due_date || "N/A",
    wdsr02: "N/A",
    referenceWindow: workItem.reference_window || "N/A",
    caaCompletion: workItem.caa_completion_date || "N/A",
    carePlanCompletionDate: workItem.care_plan_completion_date || "N/A",
    transmissionDate: workItem.transmission_date || "N/A",
    requiredTransmissionDate: "N/A",
    owner: workItem.assigned_user_name || "Unassigned",
    nextAction: "N/A",
    category: "MDS",
    work_item_id: workItem.id,
    facility_id: workItem.facility_id,
    facility_name: workItem.facility_id,
  };
}
